import { ReportFilters, ReportParameters } from '@/api/enums';

const LABOUR_ANALYSIS_WEEK_ID = 8;

const FTR_2_PARA: Readonly<Map<ReportFilters, ReportParameters>> = Object.freeze(
  new Map([
    [ReportFilters.StartDate, ReportParameters.StartDate],
    [ReportFilters.EndDate, ReportParameters.EndDate],
    [ReportFilters.StartBlock, ReportParameters.StartBlock],
    [ReportFilters.EndBlock, ReportParameters.EndBlock],
    [ReportFilters.SnapshotDate, ReportParameters.SnapshotDate],

    [ReportFilters.ActiveType, ReportParameters.ActiveType],
    [ReportFilters.Agents, ReportParameters.Agents],
    [ReportFilters.Clients, ReportParameters.ClientIds],
    [ReportFilters.DataSources, ReportParameters.DataSources],
    [ReportFilters.ShowUnmetOnly, ReportParameters.ShowUnmetOnly],
    [ReportFilters.Weeks, ReportParameters.WeekId],
    [ReportFilters.SortByName, ReportParameters.SortByName],
    [ReportFilters.ClientSchedule, ReportParameters.ClientScheduleId],
    [ReportFilters.SortByNameTime, ReportParameters.SortByNameTime],
    [ReportFilters.Workgroup, ReportParameters.DwQueueIds],
    [ReportFilters.ChatRooms, ReportParameters.ChatRoomId],

    [ReportFilters.Contract, ReportParameters.ContractId],
    [ReportFilters.Contracts, ReportParameters.ContractIds],
    [ReportFilters.Position, ReportParameters.PositionId],
    [ReportFilters.Positions, ReportParameters.PositionIds],
    [ReportFilters.Schedule, ReportParameters.ScheduleId],
    [ReportFilters.Schedules, ReportParameters.ScheduleIds],

    [ReportFilters.GigId, ReportParameters.GigId],
    [ReportFilters.Country, ReportParameters.Country],
    [ReportFilters.ESignDocumentStatus, ReportParameters.ESignDocumentStatus],
  ]),
);

export { LABOUR_ANALYSIS_WEEK_ID, FTR_2_PARA };

export const ShiftsOnOfferReport = 3;
